import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  TextField,
  Box,
  Grid,
  Typography,
  IconButton,
  Snackbar,
  Alert,
  InputAdornment,
  Card,
  CardContent,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Modal as BootstrapModal } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import InfoIcon from "@mui/icons-material/Info";
import LoopIcon from '@mui/icons-material/Loop';

const readOnlyFieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fafafa",
    "& fieldset": { borderColor: "#e0e0e0" },
  },
  "& .MuiInputLabel-root": { color: "#757575" },
};

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: "20px",
  backgroundColor: "#f9fafb",
}));

const StyledHeader = styled(Box)(({ theme }) => ({
  border: "1px solid #CC9966",
  borderRadius: "8px",
  height: "60px",
  background: "linear-gradient(90deg, #beab6c 0%, #d4c28a 100%)",
  display: "flex",
  alignItems: "center",
  padding: "0 20px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  marginBottom: "20px",
}));

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  borderRadius: "8px",
  borderLeft: "4px solid #1898c2",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "4px",
  padding: "8px 16px",
  textTransform: "none",
  fontWeight: 600,
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: "300px",
  overflowY: "auto",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  borderRadius: "8px",
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& .MuiTableCell-head": {
    backgroundColor: "#1898c2",
    color: "white",
    fontWeight: "bold",
    padding: "12px",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
}));

const CustomDateInput = React.forwardRef(
  ({ value, onClick, disabled }, ref) => (
    <TextField
      value={value}
      size="small"
      variant="outlined"
      fullWidth
      inputRef={ref}
      sx={{
        minWidth: 180,
        "& .MuiOutlinedInput-root": {
          paddingRight: "8px",
        },
      }}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={onClick}
              disabled={disabled}
              sx={{
                padding: "4px",
                "&:hover": { color: "#1898c2" },
              }}
            >
              <CalendarTodayIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
);

function FeeDeposit() {
  const [discountOtp, setDiscountOtp] = useState("");
const [discountRequestId, setDiscountRequestId] = useState(0);
const [discountReason, setDiscountReason] = useState("");
const [showDiscountOtpDialog, setShowDiscountOtpDialog] = useState(false);
const [showCancelOtpDialog, setShowCancelOtpDialog] = useState(false);
const [cancelOtp, setCancelOtp] = useState("");
const [isOtpSent, setIsOtpSent] = useState(false);
const [isCancelOtpSent, setIsCancelOtpSent] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
const [transactionIdToCancel, setTransactionIdToCancel] = useState(null);
  const [hostelCharges, setHostelCharges] = useState(0);
  const [isOnlinePayment, setIsOnlinePayment] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [messageColor, setMessageColor] = useState("success");
  const [printPaymentId, setPrintPaymentId] = useState(0);
  const [paymentOption, setPaymentOption] = useState("partial");
  const [admissionNo, setAdmissionNo] = useState("");
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [feeDetails, setFeeDetails] = useState([]);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [monthCharges, setMonthCharges] = useState({});
  const [banks, setBanks] = useState([]);
  const [paymentMode, setPaymentMode] = useState("");
  const [paidAmount, setPaidAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [concessionAmount, setConcessionAmount] = useState(0);
  const [inventoryBalance, setInventoryBalance] = useState(0);
  const [walletAmount, setWalletAmount] = useState(0);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [savedPaymentId, setSavedPaymentId] = useState(0);
  const [receiptCopies, setReceiptCopies] = useState("one");
  const [previousPaidAmount, setPreviousPaidAmount] = useState(0);
  const [transportFee, setTransportFee] = useState(0);
  const [showUserGuide, setShowUserGuide] = useState(false);
  const [monthSelectionError, setMonthSelectionError] = useState("");
  const [selectedMonthOrder, setSelectedMonthOrder] = useState([]);
  const [isMonthLoading, setIsMonthLoading] = useState(false);

  const handleSendCancelOtp = async () => {
  if (!cancelReason.trim()) {
    setSnackbarMessage("Please enter a cancellation reason.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }
  try {
    setIsLoading(true);
    const response = await fetch(`${apiUrl}/FeeDeposit/SendOtpForFeeCancellation`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ transactionId: transactionIdToCancel, cancelReason }),
    });
    if (!response.ok) throw new Error(`Failed to send OTP: ${response.status}`);
    const data = await response.json();
    if (data.status === "Succeed" || response.ok) {
      setIsCancelOtpSent(true);
      setShowCancelOtpDialog(true);
      setSnackbarMessage("OTP sent successfully.");
      setMessageColor("success");
      setSnackbarOpen(true);
    } else {
      setSnackbarMessage(data.msg || "Failed to send OTP.");
      setMessageColor("error");
      setSnackbarOpen(true);
    }
  } catch (error) {
    setSnackbarMessage(`Error: ${error.message}`);
    setMessageColor("error");
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};

const handleCancelFee = async () => {
  if (!cancelOtp.trim()) {
    setSnackbarMessage("Please enter the OTP.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }
  try {
    setIsLoading(true);
    const response = await fetch(`${apiUrl}/FeeDeposit/Adv_CancelFeeTransaction`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ transactionId: transactionIdToCancel, cancelReason, otp: cancelOtp }),
    });
    if (!response.ok) throw new Error(`Error cancelling: ${response.status}`);
    const data = await response.json();
    if (data.status === "Succeed") {
      setSnackbarMessage(`Transaction cancelled successfully.`);
      setMessageColor("success");
      setSnackbarOpen(true);
      if (selectedStudent && selectedFinancialYear)
        await fetchFeeDetails(selectedStudent.studentId, selectedFinancialYear);
    } else {
      setSnackbarMessage(data.msg || "Failed to cancel transaction.");
      setMessageColor("error");
      setSnackbarOpen(true);
    }
  } catch (error) {
    setSnackbarMessage(`Error: ${error.message}`);
    setMessageColor("error");
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setShowCancelOtpDialog(false);
    setShowCancelConfirmation(false);
    setCancelReason("");
    setCancelOtp("");
    setIsCancelOtpSent(false);
  }
};


const handleSendDiscountOtp = async () => {
  if (!discountReason.trim()) {
    setSnackbarMessage("Please enter a discount reason.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }
  if (discountAmount <= 0) {
    setSnackbarMessage("Please enter a valid discount amount.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }
  try {
    setIsLoading(true);
    const response = await fetch(`${apiUrl}/FeeDeposit/SendOtpForFeeDiscount`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({
        studentId: selectedStudent.studentId,
        sessionId: selectedFinancialYear,
        discountAmount,
        discountReason,
      }),
    });
    if (!response.ok) throw new Error(`Failed to send OTP: ${response.status}`);
    const data = await response.json();
    // Store the requestId if returned by the API
    if (data.requestId) setDiscountRequestId(data.requestId);   
     setIsOtpSent(true);
    setSnackbarMessage("Discount OTP sent successfully.");
    setMessageColor("success");
    setSnackbarOpen(true);
  } catch (error) {
    setSnackbarMessage(`Error: ${error.message}`);
    setMessageColor("error");
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};

const handlePaymentModeChange = (e) => {
  const selectedBankId = e.target.value;
  setPaymentMode(selectedBankId);
  
  // Check if selected payment mode contains "Online"
  const selectedBank = banks.find(bank => bank.bankId === selectedBankId);
  setIsOnlinePayment(selectedBank?.bankName?.toLowerCase().includes('online'));
};

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");

  const formatDate = (date) => {
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  const fetchDdlClass = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching class data: ${response.status}`);
      }

      const data = await response.json();
      setClasses(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching classes:", error);
      setClasses([]);
      setSnackbarMessage("Failed to fetch class data");
      setMessageColor("warning");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, token]);

  const fetchFinancialYears = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${apiUrl}/ClassPromotion/GetFinancialYear`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }

      const data = await response.json();
      setFinancialYears(Array.isArray(data) ? data : []);
      const currentYear = new Date().getFullYear();
      const currentFinancialYear = data.find((year) =>
        year.finanacialYear.includes(`${currentYear}-${currentYear + 1}`)
      );
      if (currentFinancialYear) {
        setSelectedFinancialYear(currentFinancialYear.financialYearID);
      }
    } catch (error) {
      console.error("Error fetching financial years:", error);
      setFinancialYears([]);
      setSnackbarMessage("Failed to fetch financial years");
       setMessageColor("warning")
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, token]);

  const fetchStudents = useCallback(
    async (classId) => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiUrl}/FeeDeposit/SerachAdmissionListMonthly`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({ classId: classId }),
          }
        );

        if (!response.ok) {
          throw new Error(`Error fetching student data: ${response.status}`);
        }

        const data = await response.json();
        const uniqueStudents = Array.from(
          new Map(data.map((item) => [item.studentId, item])).values()
        );
        setStudents(Array.isArray(uniqueStudents) ? uniqueStudents : []);
      } catch (error) {
        console.error("Error fetching students:", error);
        setStudents([]);
        setSnackbarMessage("Failed to fetch student data");
         setMessageColor("warning")
        setSnackbarOpen(true);
      } finally {
        setIsLoading(false);
      }
    },
    [apiUrl, token]
  );

  const fetchFeeDetails = useCallback(
    async (studentId, sessionId) => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiUrl}/FeeDeposit/GetMonthFeeDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({ studentId, sessionId }),
          }
        );

        if (!response.ok) {
          throw new Error(`Error fetching fee details: ${response.status}`);
        }

        const data = await response.json();
        const today = new Date();
        const formattedToday = formatDate(today);
        const initializedData = data.map((fee) => {
          let paymentDate = formattedToday;
          if (fee.paidStaus === 1 && fee.date) {
            const [day, month, year] = fee.date.split("/");
            paymentDate = `${day}-${month}-${year}`;
          }
          return {
            ...fee,
            paymentDate,
            fine: 0,
          };
        });
        setFeeDetails(Array.isArray(initializedData) ? initializedData : []);
        // Reset previous paid amount since no payments are selected initially
        setPreviousPaidAmount(0);
        setSelectedPayments([]);
      } catch (error) {
        console.error("Error fetching fee details:", error);
        setFeeDetails([]);
        setPreviousPaidAmount(0);
        setSnackbarMessage("Failed to fetch fee details");
         setMessageColor("warning")
        setSnackbarOpen(true);
      } finally {
        setIsLoading(false);
      }
    },
    [apiUrl, token]
  );

  const fetchMonthCharges = useCallback(
    async (feePaymentId, studentId, classId, monthId) => {
      try {
        const response = await fetch(
          `${apiUrl}/FeeDeposit/GetClassCharger_MonthFee`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({
              feePaymentId,
              studentId,
              classId,
              monthId,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Error fetching month charges: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
      } catch (error) {
        console.error("Error fetching month charges:", error);
        return [];
      }
    },
    [apiUrl, token]
  );

  const fetchFineAmount = useCallback(
    async (studentId, monthId, recieptDate) => {
      try {
        const response = await fetch(`${apiUrl}/FeeDeposit/FetchFineAmount`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            studentId,
            monthId,
            recieptDate,
          }),
        });

        if (!response.ok) {
          throw new Error(`Error fetching fine amount: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) && data.length > 0
          ? data[0]
          : { fineAmount: 0, day: 0, month: 0, chargePerDay: 0 };
      } catch (error) {
        console.error("Error fetching fine amount:", error);
        return { fineAmount: 0, day: 0, month: 0, chargePerDay: 0 };
      }
    },
    [apiUrl, token]
  );

  const fetchBanks = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${apiUrl}/Bank/GetBank`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching bank data: ${response.status}`);
      }

      const data = await response.json();
      setBanks(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching banks:", error);
      setBanks([]);
      setSnackbarMessage("Failed to fetch bank data");
       setMessageColor("warning")
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, token]);

  const fetchConcessionAndTransport = useCallback(
    async (studentId, monthId) => {
      try {
        const today = new Date();
        const recieptDate = `${today.getDate().toString().padStart(2, "0")}/${(
          today.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${today.getFullYear()}`;
        const response = await fetch(
          `${apiUrl}/FeeDeposit/GetAmountbyStudentId`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({
              studentId,
              monthId,
              recieptDate,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            `Error fetching concession and transport: ${response.status}`
          );
        }

        const data = await response.json();
        return {
          concessionAmount: data.objData?.concessionAmount || 0,
          transportFee: data.objData?.transportFee || 0,
          hostelCharges: data.objData?.hostelCharges || 0, 

        };
      } catch (error) {
        console.error("Error fetching concession and transport:", error);
        return { concessionAmount: 0, transportFee: 0 };
      }
    },
    [apiUrl, token]
  );

  useEffect(() => {
    fetchDdlClass();
    fetchFinancialYears();
    fetchBanks();
  }, [fetchDdlClass, fetchFinancialYears, fetchBanks]);

  useEffect(() => {
    if (selectedStudent && selectedFinancialYear) {
      fetchFeeDetails(selectedStudent.studentId, selectedFinancialYear);
    }
  }, [selectedStudent, selectedFinancialYear, fetchFeeDetails]);

 useEffect(() => {
  if (selectedPayments.length > 0 && selectedStudent) {
    const totalConcession = selectedPayments.reduce((sum, id) => {
      return sum + (monthCharges[id]?.concession || 0);
    }, 0);
    const totalTransportFee = selectedPayments.reduce((sum, id) => {
      return sum + (monthCharges[id]?.transportFee || 0);
    }, 0);
    const totalHostelCharges = selectedPayments.reduce((sum, id) => {
      return sum + (monthCharges[id]?.hostelCharges || 0);  // ADD THIS
    }, 0);
    setConcessionAmount(totalConcession);
    setTransportFee(totalTransportFee);
    setHostelCharges(totalHostelCharges);  // ADD THIS
  } else {
    setConcessionAmount(0);
    setTransportFee(0);
    setHostelCharges(0);  // ADD THIS
  }
}, [selectedPayments, monthCharges, selectedStudent]);

const calculateTotalMonthlyFee = useCallback(() => {
  return selectedPayments.reduce((sum, id) => {
    const fee = feeDetails.find((f) => f.feePaymentId === id);
    const charges = monthCharges[id]?.charges || [];
    const chargeTotal = charges.reduce(
      (acc, charge) => acc + (charge.chargerAmount || 0),
      0
    );
    const transport = monthCharges[id]?.transportFee || 0;
    const hostel = monthCharges[id]?.hostelCharges || 0;  // ADD THIS
    return sum + chargeTotal + (fee?.fine || 0) + transport + hostel;  // ADD hostel
  }, 0);
}, [selectedPayments, feeDetails, monthCharges]);

  const calculateAmountAfterDiscount = useCallback(() => {
    if (!selectedStudent || selectedPayments.length === 0) {
      return 0;
    }
    const balanceBeforeDiscount =
      calculateTotalMonthlyFee() -
      previousPaidAmount -
      paidAmount -
      concessionAmount;
    return balanceBeforeDiscount - discountAmount;
  }, [
    calculateTotalMonthlyFee,
    previousPaidAmount,
    paidAmount,
    concessionAmount,
    discountAmount,
    selectedStudent,
    selectedPayments,
  ]);

  const calculateMonthlyBalance = useCallback(() => {
    if (!selectedStudent || selectedPayments.length === 0) {
      return 0;
    }
    return (
      calculateTotalMonthlyFee() -
      previousPaidAmount -
      paidAmount -
      discountAmount -
      concessionAmount
    );
  }, [
    calculateTotalMonthlyFee,
    previousPaidAmount,
    paidAmount,
    discountAmount,
    concessionAmount,
    selectedStudent,
    selectedPayments,

  ]);

  const handlePaymentOptionChange = (event) => {
    const value = event.target.value;
    setPaymentOption(value);
    if (value === "annual") {
      navigate("/annual-payment");
    } else if (value === "partial") {
      navigate("/feedeposit/NDY=");
      setSelectedStudent(null);
      setAdmissionNo("");
      setStudents([]);
      setSelectedClass("");
      setIsSaved(false);
      setFeeDetails([]);
      setSelectedPayments([]);
      setMonthCharges({});
      setPaidAmount(0);
      setDiscountAmount(0);
      setConcessionAmount(0);
      setInventoryBalance(0);
      setWalletAmount(0);
      setAdvanceAmount(0);
      setPaymentMode("");
      setSelectedFinancialYear(
        financialYears.find((year) =>
          year.finanacialYear.includes(
            `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`
          )
        )?.financialYearID || ""
      );
    }
  };

  const handleSearchClick = () => {
    setShowStudentModal(true);
  };

  const handleClassChange = (event) => {
    const classId = event.target.value;
    setSelectedClass(classId);
    if (classId) {
      fetchStudents(classId);
    } else {
      setStudents([]);
    }
  };

  const handleChargeAmountChange = (event, feePaymentId, chargeIndex) => {
    const value = parseFloat(event.target.value) || 0;
    setMonthCharges((prev) => {
      const updatedCharges = [...(prev[feePaymentId]?.charges || [])];
      updatedCharges[chargeIndex] = {
        ...updatedCharges[chargeIndex],
        chargerAmount: value,
      };
      return {
        ...prev,
        [feePaymentId]: {
          ...prev[feePaymentId],
          charges: updatedCharges,
        },
      };
    });
  };

  const handleStudentSelect = (student) => {
    setSelectedStudent(student);
    setAdmissionNo(student.admissionNo);
    setShowStudentModal(false);
    setIsSaved(false);
    setMonthCharges({});
    setPaidAmount(0);
    setDiscountAmount(0);
    setConcessionAmount(0);
    setInventoryBalance(0);
    setWalletAmount(0);
    setAdvanceAmount(0);
    setPaymentMode("");
    setSelectedPayments([]); // Reset selected payments
    setMonthSelectionError(""); // Reset month selection error
    setSelectedMonthOrder([]); // Reset selected month order
  };

  const handleFinancialYearChange = (event) => {
    setSelectedFinancialYear(event.target.value);
    setMonthCharges({});
  };

  const handlePaymentSelect = async (feePaymentId) => {
    if (!selectedStudent) return;

    const isSelected = selectedPayments.includes(feePaymentId);
    let newSelectedPayments = [...selectedPayments];
    const fee = feeDetails.find((f) => f.feePaymentId === feePaymentId);
    if (!fee) return;

    // Define month order (assuming months are in chronological order in feeDetails)
    const monthOrder = feeDetails.map((f) => ({
      feePaymentId: f.feePaymentId,
      monthId: f.monthId,
      monthName: f.monthName,
    }));

    if (isSelected) {
      // Deselect the month
      newSelectedPayments = selectedPayments.filter(
        (id) => id !== feePaymentId
      );
      setMonthCharges((prev) => {
        const updated = { ...prev };
        delete updated[feePaymentId];
        return updated;
      });
      setPreviousPaidAmount((prev) => prev - (fee?.paidAmount || 0));
      // Update selected month order
      setSelectedMonthOrder((prev) =>
        prev.filter((item) => item.feePaymentId !== feePaymentId)
      );
      setMonthSelectionError("");
    } else {
      // Check if the selection is valid (consecutive months)
      if (selectedMonthOrder.length > 0) {
        const lastSelectedMonth =
          selectedMonthOrder[selectedMonthOrder.length - 1];
        const lastIndex = monthOrder.findIndex(
          (m) => m.feePaymentId === lastSelectedMonth.feePaymentId
        );
        const currentIndex = monthOrder.findIndex(
          (m) => m.feePaymentId === feePaymentId
        );

        // Prevent selecting non-consecutive or previous months
        if (currentIndex !== lastIndex + 1) {
          setMonthSelectionError(
            `Please select the next consecutive month after ${lastSelectedMonth.monthName}.`
          );
          setSnackbarMessage(
            `Please select the next consecutive month after ${lastSelectedMonth.monthName}.`
          );
          setMessageColor("warning");
          setSnackbarOpen(true);
          return;
        }
      }

      // Add the new month to the selected payments
      newSelectedPayments.push(feePaymentId);
      setSelectedMonthOrder((prev) => [
        ...prev,
        { feePaymentId, monthId: fee.monthId, monthName: fee.monthName },
      ]);

      if (selectedStudent) {
        setIsMonthLoading(true); // Start loading
        try {
          const [day, month, year] = fee.paymentDate.split("-");
          const recieptDate = `${day}/${month}/${year}`;
          const charges = await fetchMonthCharges(
            feePaymentId,
            selectedStudent.studentId,
            selectedStudent.classId,
            fee.monthId
          );
          const fineDetails = await fetchFineAmount(
            selectedStudent.studentId,
            fee.monthId,
            recieptDate
          );
          const { concessionAmount, transportFee: fetchedTransportFee, hostelCharges: fetchedHostelCharges } =
  await fetchConcessionAndTransport(
    selectedStudent.studentId,
    fee.monthId,
    recieptDate
  );
setMonthCharges((prev) => ({
  ...prev,
  [feePaymentId]: {
    charges,
    fineDetails,
    concession: concessionAmount,
    transportFee: fetchedTransportFee,
    hostelCharges: fetchedHostelCharges,  // ADD THIS
  },
}));
          setFeeDetails((prev) =>
            prev.map((f) =>
              f.feePaymentId === feePaymentId
                ? { ...f, fine: fineDetails.fineAmount }
                : f
            )
          );
          setPreviousPaidAmount((prev) => prev + (fee.paidAmount || 0));
        } catch (error) {
          console.error("Error fetching month details:", error);
          setSnackbarMessage(
            "Failed to fetch month details. Please try again."
          );
          setMessageColor("warning");
          setSnackbarOpen(true);
          newSelectedPayments = newSelectedPayments.filter(
            (id) => id !== feePaymentId
          ); // Revert selection
          setSelectedMonthOrder((prev) =>
            prev.filter((item) => item.feePaymentId !== feePaymentId)
          );
        } finally {
          setIsMonthLoading(false); // Stop loading
        }
        setMonthSelectionError("");
      }
    }

    setSelectedPayments(newSelectedPayments);
  };

  const handleConcessionChange = (event, feePaymentId) => {
    const value = parseFloat(event.target.value) || 0;
    setMonthCharges((prev) => ({
      ...prev,
      [feePaymentId]: {
        ...prev[feePaymentId],
        concession: value,
      },
    }));
  };

  const handleDateChange = (date, feePaymentId) => {
    const formattedDate = date ? formatDate(date) : formatDate(new Date());
    setFeeDetails((prev) =>
      prev.map((fee) =>
        fee.feePaymentId === feePaymentId
          ? { ...fee, paymentDate: formattedDate }
          : fee
      )
    );
  };

  const handleFineChange = (event, feePaymentId) => {
    const value = parseFloat(event.target.value) || 0;
    setFeeDetails((prev) =>
      prev.map((fee) =>
        fee.feePaymentId === feePaymentId ? { ...fee, fine: value } : fee
      )
    );
  };

  const handlePaySelected = () => {
    if (selectedPayments.length === 0) {
      setSnackbarMessage(
        "Please select at least one unpaid payment to proceed."
      );
       setMessageColor("warning")
      setSnackbarOpen(true);
      return;
    }
    if (!paymentMode) {
      setSnackbarMessage("Please select a payment mode.");
       setMessageColor("warning")
      setSnackbarOpen(true);
      return;
    }
    setSnackbarMessage(
      `Processing payment for ${selectedPayments.length} selected months`
    );
     setMessageColor("warning")
    setSnackbarOpen(true);
    setIsSaved(true);
  };

  const handleCancel = () => {
    setDiscountOtp("");
setDiscountRequestId(0);
setDiscountReason("");
setIsOtpSent(false);
setShowDiscountOtpDialog(false);
setShowCancelOtpDialog(false);
setCancelOtp("");
setIsCancelOtpSent(false);
    setSelectedStudent(null);
    setAdmissionNo("");
    setStudents([]);
    setSelectedClass("");
    setIsSaved(false);
    setFeeDetails([]);
    setSelectedPayments([]);
    setMonthCharges({});
    setPaidAmount(0);
    setDiscountAmount(0);
    setConcessionAmount(0);
    setInventoryBalance(0);
    setWalletAmount(0);
    setAdvanceAmount(0);
    setPaymentMode("");
    setMonthSelectionError(""); // Reset month selection error
    setSelectedMonthOrder([]); // Reset selected month order
  };

  const handlePayOnline = async () => {
  if (!selectedStudent || selectedPayments.length === 0) {
    setSnackbarMessage("Please select a student and at least one month.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }

  try {
    setIsLoading(true);

    const firstSelectedMonth = feeDetails.find(
      f => f.feePaymentId === selectedPayments[0]
    );

    const body = {
      studentId: selectedStudent.studentId,
      feeType: "Monthly",
      monthId: firstSelectedMonth?.monthId || 0,
      amount: parseFloat(paidAmount)
    };

    const response = await fetch(`${apiUrl}/Payments/CreateOnlineOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error(`Failed to create online order: ${response.status}`);
    }

    const data = await response.json();

    // Setup Razorpay options
    const options = {
      key: data.keyId,
      amount: data.amountInPaise,
      currency: data.currency,
      name: sessionStorage.getItem("schoolName") || 'School',
      description: 'Fee Payment',
      order_id: data.orderId,
      handler: function (razorpayResponse) {
        // On successful payment, submit fee deposit
        handlePartialPaymentSubmit(razorpayResponse);
      },
      prefill: {
        name: selectedStudent.studentName,
        email: selectedStudent.email || '',
        contact: selectedStudent.mobileNo || ''
      },
      theme: { color: '#1898c2' },
      modal: {
        ondismiss: function() {
          setIsLoading(false);
          setSnackbarMessage("Payment cancelled by user");
          setMessageColor("warning");
          setSnackbarOpen(true);
        }
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    setIsLoading(false);

  } catch (error) {
    console.error("Error initiating online payment:", error);
    setSnackbarMessage(`Failed to initiate online payment: ${error.message}`);
    setMessageColor("warning");
    setSnackbarOpen(true);
    setIsLoading(false);
  }
};

 const handlePartialPaymentSubmit = async (razorpayResponse = null) => {
    if (!selectedStudent) {
      setSnackbarMessage("Please select a student before proceeding.");
      setMessageColor("warning");
      setSnackbarOpen(true);
      return;
    }
    if (!paymentMode) {
      setSnackbarMessage("Please select a payment mode.");
      setMessageColor("warning");
      setSnackbarOpen(true);
      return;
    }
    if (selectedPayments.length === 0) {
      setSnackbarMessage("Please select at least one month to proceed.");
      setMessageColor("warning");
      setSnackbarOpen(true);
      return;
    }

    // Validate consecutive months
    const monthOrder = feeDetails.map((f) => ({
      feePaymentId: f.feePaymentId,
      monthId: f.monthId,
      monthName: f.monthName,
    }));
    const selectedIndices = selectedPayments.map((id) =>
      monthOrder.findIndex((m) => m.feePaymentId === id)
    );
    const isConsecutive = selectedIndices.every(
      (index, i, arr) => i === 0 || index === arr[i - 1] + 1
    );

    if (!isConsecutive) {
      setSnackbarMessage("Selected months must be consecutive.");
      setMessageColor("warning");
      setSnackbarOpen(true);
      return;
    }

    try {
      setIsLoading(true);

      const monthFee = selectedPayments.map((feePaymentId) => {
        const fee = feeDetails.find((f) => f.feePaymentId === feePaymentId);
        const charges = monthCharges[feePaymentId]?.charges || [];
        const chargeTotal = charges.reduce(
          (acc, charge) => acc + (charge.chargerAmount || 0),
          0
        );
        const transport = monthCharges[feePaymentId]?.transportFee || 0;
        const hostelFee = monthCharges[feePaymentId]?.hostelCharges || 0;
        
        return {
          feePaymentId: fee.feePaymentId,
          isMonthCheck: true,
          totalFee: chargeTotal + (fee?.fine || 0) + transport + hostelFee,
          concessionAmount: monthCharges[fee.feePaymentId]?.concession || 0,
          paidAmount: fee.paidAmount || 0,
          fine: fee.fine || 0,
          paidStaus: fee.paidStaus || 0,
          monthId: fee.monthId,
          month: fee.monthName,
        };
      });

      const feeCharge = selectedPayments.flatMap((feePaymentId) =>
        (monthCharges[feePaymentId]?.charges || []).map((charge) => ({
          chargeId: charge.chargerId,
          chargerAmount: charge.chargerAmount || 0,
        }))
      );

      const months = selectedPayments
        .map((id) => feeDetails.find((f) => f.feePaymentId === id)?.monthName)
        .filter(Boolean)
        .join(",");

      const paymentDate = `${new Date()
        .getDate()
        .toString()
        .padStart(2, "0")}/${(new Date().getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${new Date().getFullYear()}`;

    const payload = {
  walleteAmount: walletAmount,
  paidStatus: true,
  feePaymentId: 0,
  studentId: selectedStudent.studentId,
  advanceAmount: advanceAmount,
  fineAmount: selectedPayments.reduce(
    (sum, id) =>
      sum + (feeDetails.find((f) => f.feePaymentId === id)?.fine || 0),
    0
  ),
  paidAmount: paidAmount,
  month: months,
  monthId: monthFee[0]?.monthId || 0,
  sessionId: selectedFinancialYear,
  checqueNo: "0",
  checqueDate: "01/01/2020",
  paymentDate,
  paymentMode:
    banks.find((bank) => bank.bankId === paymentMode)?.bankName || "",
  paymentModeId: paymentMode,
  balance: calculateMonthlyBalance(),
  discount: discountAmount,
  concessionAmount: concessionAmount,
  previousPaidAmount: previousPaidAmount,
  monthFee,
  feeCharge,
  isConsecutiveMonths: isConsecutive,
  // ✅ ADD THESE TWO LINES HERE:
  discountRequestId: discountRequestId,
  discountOtp: discountOtp,
  // Razorpay block stays below
  ...(razorpayResponse && {
    razorpayPaymentId: razorpayResponse.razorpay_payment_id,
    razorpayOrderId: razorpayResponse.razorpay_order_id,
    razorpaySignature: razorpayResponse.razorpay_signature
  })
};

      const response = await fetch(`${apiUrl}/FeeDeposit/Adv_FeeDepositMonthly`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        setSnackbarMessage(
          data?.objreponse?.msg ||
            `Error saving payment: HTTP ${response.status}`
        );
        setMessageColor("warning");
        setSnackbarOpen(true);
        return;
      }

      if (data.objreponse?.status !== "Succeed!") {
        setSnackbarMessage(
          data.objreponse?.msg ||
            "Failed to save payment due to an unknown error."
        );
        setMessageColor("warning");
        setSnackbarOpen(true);
        return;
      }

      setSavedPaymentId(data.paymentId);
      setIsSaved(true);
      setShowSuccessModal(true);
      setSelectedPayments([]);
      setMonthCharges({});
      setPaidAmount(0);
      setDiscountAmount(0);
      setConcessionAmount(0);
      setPreviousPaidAmount(0);
      setTransportFee(0);
      setIsSaved(false);
      setMonthSelectionError("");
      setSelectedMonthOrder([]);
      await fetchFeeDetails(selectedStudent.studentId, selectedFinancialYear);
      setSnackbarMessage(data.objreponse?.msg || "Payment saved successfully.");
      setMessageColor("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error saving payment:", error);
      setSnackbarMessage(
        error.message || "Failed to save payment. Please try again."
      );
      setMessageColor("warning");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBranchDetails = async () => {
    try {
      const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching branch details: ${response.status}`);
      }

      const data = await response.json();
      return Array.isArray(data) && data.length > 0 ? data[0] : {};
    } catch (error) {
      console.error("Error fetching branch details:", error);
      setSnackbarMessage("Failed to fetch branch details");
       setMessageColor("warning")
      setSnackbarOpen(true);
      return {};
    }
  };

  const generateReceipt = async (id = savedPaymentId, fromTable = false) => {
  if (!id) {
    setSnackbarMessage("No payment ID available for receipt generation.");
    setMessageColor("warning");
    setSnackbarOpen(true);
    return;
  }

  try {
    setIsLoading(true);

    const response = await fetch(`${apiUrl}/FeeDeposit/MonthFeeReciept`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ paymentId: id }),
    });

    if (!response.ok) {
      throw new Error(`Error retrieving receipt data: ${response.status}`);
    }

    const data = await response.json();

    if (!data?.list?.length || !data?.chargerList) {
      throw new Error("Receipt data is empty or invalid.");
    }

    const receiptData = data.list[0];
    const charges = data.chargerList;

    if (!receiptData.recieptNo || !receiptData.studentName || !receiptData.month) {
      throw new Error("Critical receipt fields are missing.");
    }

    const branchData = await fetchBranchDetails();
    const schoolName =
      sessionStorage.getItem("schoolName") ||
      branchData?.organisationName ||
      "JEEVAN ADARSH VIDYALAYA";
    const logoBase64 = branchData.bytLogo
      ? `data:image/jpeg;base64,${branchData.bytLogo}`
      : null;

    const generateSingleReceipt = (doc, isCopy = false, isFirstReceipt = true) => {
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 4;
      const contentWidth = (pageWidth - 3 * margin) / 2;
      const startX = isFirstReceipt ? margin : margin * 2 + contentWidth;
      let yPos = margin + 2;

      doc.setLineWidth(0.5);
      doc.setDrawColor(50, 50, 50);
      doc.rect(startX, margin, contentWidth, pageHeight - 2 * margin);

      if (logoBase64) {
        try {
          const logoWidth = 14;
          const imgProps = doc.getImageProperties(logoBase64);
          const aspectRatio = imgProps.width / imgProps.height;
          const calculatedHeight = logoWidth / aspectRatio;
          doc.addImage(logoBase64, "JPEG", startX + 3, yPos, logoWidth, calculatedHeight);
        } catch (error) {
          console.error("Error adding logo to PDF:", error);
          doc.setFontSize(6.5);
          doc.text("No Logo Available", startX + 3, yPos + 8);
        }
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      const schoolNameLines = doc.splitTextToSize(schoolName, contentWidth - 20);
      doc.text(schoolNameLines, startX + 20, yPos + 3);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6.5);
      const addressLines = doc.splitTextToSize(
        `Address: ${branchData.branchAddress || "Not Available"}`,
        contentWidth - 20
      );
      doc.text(addressLines, startX + 20, yPos + 8);
      yPos += 10 + addressLines.length * 3;
      doc.text(`Email: ${branchData.emailID || "Not Available"}`, startX + 20, yPos);
      yPos += 3.5;
      doc.text(`Phone: ${branchData.mobileNo || "Not Available"}`, startX + 20, yPos);

      yPos += 6;
      doc.setFontSize(7);
      doc.setFont("helvetica", "bold");
      doc.text(
        `FEE RECEIPT${isCopy ? " (Copy)" : ""}`,
        startX + contentWidth / 2,
        yPos,
        { align: "center" }
      );

      yPos += 1;
      doc.setLineWidth(0.2);
      doc.setDrawColor(150, 150, 150);
      doc.line(startX + 2, yPos, startX + contentWidth - 2, yPos);

      yPos += 3;
      doc.setFontSize(6.5);
      doc.setFont("helvetica", "bold");
      doc.text("Student Information", startX + 2, yPos);
      doc.setFont("helvetica", "normal");

      yPos += 4;
      doc.text(`Receipt No: ${receiptData.recieptNo || "N/A"}`, startX + 2, yPos);
      doc.text(`Date: ${receiptData.feePaymentDate || "N/A"}`, startX + contentWidth / 2, yPos);
      yPos += 4;
      doc.text(`Student Name: ${receiptData.studentName || "N/A"}`, startX + 2, yPos);
      doc.text(`Admission No: ${receiptData.admissionNo || "N/A"}`, startX + contentWidth / 2, yPos);
      yPos += 4;
      doc.text(`Class: ${receiptData.class || "N/A"}`, startX + 2, yPos);
      doc.text(`Month(s): ${receiptData.month || "N/A"}`, startX + contentWidth / 2, yPos);

      yPos += 2;
      doc.line(startX + 2, yPos, startX + contentWidth - 2, yPos);
      yPos += 3;

      const tableBody = charges.length
        ? charges.map((charge) => [
            charge.chargeName || "Unknown Charge",
            `Rs. ${(charge.chargeAmount || 0).toFixed(2)}`,
          ])
        : [["No Charges", "₹0.00"]];

      tableBody.push(["Total Month Charges", `Rs. ${(data.monthCharges || 0).toFixed(2)}`]);
      tableBody.push(["Transport Charges", `Rs. ${(receiptData.transportFee || 0).toFixed(2)}`]);
      tableBody.push(["Hostel Charges", `Rs. ${(receiptData.hostelFee || 0).toFixed(2)}`]);
      tableBody.push(["Fine Amount", `Rs. ${(receiptData.fineAmount || 0).toFixed(2)}`]);
      tableBody.push(["Total Charges", `Rs. ${(data.totalChargeAmount || 0).toFixed(2)}`]);
      tableBody.push(["Concession(-)", `Rs. ${(receiptData.concessionAmount || 0).toFixed(2)}`]);
      tableBody.push(["Discount(-)", `Rs. ${(receiptData.discountAmount || 0).toFixed(2)}`]);
      tableBody.push(["Previous Paid Amount", `Rs. ${(receiptData.previousPaidAmount || 0).toFixed(2)}`]);
      tableBody.push(["Pay Amount", `Rs. ${(receiptData.paidAmount || 0).toFixed(2)}`]);
      tableBody.push(["Balance", `Rs. ${(receiptData.balance || 0).toFixed(2)}`]);

      doc.autoTable({
        startY: yPos,
        startX: startX + 2,
        head: [["Description", "Amount"]],
        body: tableBody,
        theme: "grid",
        styles: {
          fontSize: 6.5,
          cellPadding: 1.2,
          textColor: [0, 0, 0],
          lineColor: [100, 100, 100],
          lineWidth: 0.1,
        },
        headStyles: {
          fillColor: [24, 152, 194],
          textColor: [255, 255, 255],
          fontSize: 7,
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: contentWidth * 0.6, halign: "left" },
          1: { cellWidth: contentWidth * 0.3, halign: "right" },
        },
        margin: { left: startX + 2, right: startX + 4 },
        didParseCell: function (data) {
          if (data.row.section === 'body' && data.row.raw[0] === "Total Charges") {
            data.cell.styles.fillColor = [173, 216, 230];
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fontStyle = "bold";
          }
          else if (data.row.section === 'body' && data.row.raw[0] === "Total Month Charges") {
            data.cell.styles.fillColor = [173, 216, 230];
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fontStyle = "bold";
          }
        },
      });

      yPos = doc.lastAutoTable.finalY + 4;
      doc.setFontSize(6.5);
      doc.setFont("helvetica", "normal");
      doc.text("Authorized Signatory: ____________________", startX + contentWidth - 2, yPos, {
        align: "right",
      });

      yPos += 4;
      doc.setFont("helvetica", "italic");
      doc.text(
        "This is a computer-generated receipt and does not require a signature.",
        startX + contentWidth / 2,
        yPos,
        { align: "center" }
      );
    };

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a5",
    });

    if (receiptCopies === "one") {
      generateSingleReceipt(doc, false, true);
      const margin = 4;
      const pageWidth = doc.internal.pageSize.getWidth();
      const contentWidth = (pageWidth - 3 * margin) / 2;
    
    } else {
      generateSingleReceipt(doc, false, true);
      generateSingleReceipt(doc, true, false);
    }

    const pdfBlob = doc.output("blob");
    if (!pdfBlob || !(pdfBlob instanceof Blob)) {
      throw new Error("Failed to generate valid PDF blob.");
    }

    const pdfUrl = URL.createObjectURL(pdfBlob);
    try {
      const newWindow = window.open(pdfUrl, "_blank");
      if (!newWindow) {
        throw new Error(
          "Browser blocked opening new tab. Please allow pop-ups or download the PDF manually."
        );
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `Fee_Receipt_${receiptData.recieptNo || "Unknown"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setSnackbarMessage("Unable to open PDF in new tab. The file has been downloaded instead.");
      setMessageColor("warning");
      setSnackbarOpen(true);
    } finally {
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
    }

    if (!fromTable) {
      setShowSuccessModal(false);
      setSavedPaymentId(0);
      setReceiptCopies("one");
      setSelectedPayments([]);
      setMonthCharges({});
      setPaidAmount(0);
      setDiscountAmount(0);
      setConcessionAmount(0);
      setPreviousPaidAmount(0);
      setTransportFee(0);
      setIsSaved(false);
      fetchFeeDetails(selectedStudent.studentId, selectedFinancialYear);
    }

    setSnackbarMessage("Receipt generated successfully.");
    setMessageColor("success");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error generating receipt:", error);
    setSnackbarMessage(`Error generating receipt: ${error.message}`);
    setMessageColor("warning");
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};




  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handlePaidAmountChange = (event) => {
    let value = parseFloat(event.target.value);

    // Handle NaN case (when field is empty)
    if (isNaN(value)) {
      value = 0;
    }

    // Prevent negative values completely
    value = Math.max(0, value);  // This ensures value is never negative

    const newMonthlyBalance =
      calculateTotalMonthlyFee() -
      value -
      previousPaidAmount -
      discountAmount -
      concessionAmount;
    if (newMonthlyBalance < 0) {
      setSnackbarMessage("Please enter valid amount");
       setMessageColor("warning")
      setSnackbarOpen(true);
      return;
    }
    setPaidAmount(value);
  };

  const handleDiscountAmountChange = (event) => {
    let value = parseFloat(event.target.value);

    // Handle NaN case (when field is empty)
    if (isNaN(value)) {
      value = 0;
    }

    // Prevent negative values completely
    value = Math.max(0, value);  // This ensures value is never negative
    const newMonthlyBalance =
      calculateTotalMonthlyFee() -
      paidAmount -
      previousPaidAmount -
      value -
      concessionAmount;
    if (newMonthlyBalance < 0) {
      setSnackbarMessage("Please enter valid amount");
       setMessageColor("warning")
      setSnackbarOpen(true);
      return;
    }
    setDiscountAmount(value);
  };

  return (
    <StyledContainer>
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          color: "#d32f2f",
          marginBottom: "16px",
          textAlign: "center",
          backgroundColor: "#ffebee",
          padding: "10px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          animation: "pulse 2s infinite",
        }}
      >
        Note: Please click the Cancel button after completing a payment to reset
        the form and avoid errors.
      </Typography>
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1400,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <StyledHeader>
        <RadioGroup
          row
          value={paymentOption}
          onChange={handlePaymentOptionChange}
        >
          <FormControlLabel
            value="partial"
            control={<Radio />}
            label="Monthly Payment"
            sx={{
              "& .MuiFormControlLabel-label": {
                color: "white",
                fontWeight: "600",
              },
            }}
          />
          {/* <FormControlLabel
            value="annual"
            control={<Radio />}
            label="Annual Pack Payment"
            sx={{
              "& .MuiFormControlLabel-label": {
                color: "white",
                fontWeight: "600",
              },
            }}
          /> */}
        </RadioGroup>
        <Tooltip title="View User Guide">
          <IconButton
            onClick={() => setShowUserGuide(true)}
            sx={{ color: "white", marginLeft: "auto" }}
          >
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </StyledHeader>
      {/* User Guide Dialog */}
      <Dialog
        open={showUserGuide}
        onClose={() => setShowUserGuide(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            backgroundColor: "#f9fafb",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(90deg, #1898c2 0%, #beab6c 100%)",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            borderRadius: "12px 12px 0 0",
            py: 2,
          }}
        >
          Fee Deposit User Guide
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Typography
            variant="h6"
            sx={{
              color: "#1898c2",
              fontWeight: "600",
              mb: 2,
              mt: 1,
              textAlign: "center",
            }}
          >
            Quick Steps to Process Fee Payments
          </Typography>
          <Box
            component="ul"
            sx={{
              listStyleType: "none",
              padding: 0,
              "& li": {
                display: "flex",
                alignItems: "flex-start",
                mb: 1.5,
                fontSize: "0.9rem",
                color: "#333",
              },
              "& li::before": {
                content: '"\\2022"', // Bullet point
                color: "#1898c2",
                fontWeight: "bold",
                display: "inline-block",
                width: "1.5em",
                mr: 1,
                fontSize: "1.2rem",
              },
              "& strong": {
                margin: "0 0.2em", // Add spacing around strong tags
              },
            }}
          >
            <li>
              Choose <strong>Monthly</strong> or <strong>Annual</strong> payment
              option from the header.
            </li>
            <li>
              Click <strong>Select Student</strong> to pick a student by class
              or admission number.
            </li>
            <li>
              Select a <strong>financial year</strong> from the dropdown to view
              fee details.
            </li>
            <li>
              Check the box in the <strong>Payment for Month Details</strong>{" "}
              table to select month(s).
            </li>
            <li>
              Adjust <strong>fine</strong> or <strong>concession</strong>{" "}
              amounts if needed.
            </li>
            <li>
              Enter the paid amount, discount if applicable and select a payment
              mode in the "Fee Calculation" section.
            </li>
            <li>
              Click <strong>Save</strong> to process the payment.
            </li>
            <li>
              Click <strong>Generate Receipt</strong> to download the fee
              receipt.
            </li>
            <li>
              To pay for another month, repeat the above steps after generating
              the receipt.
            </li>
            <li>
              Use the <strong>Cancel</strong> button to reset the form if
              necessary.
            </li>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <StyledButton
            onClick={() => setShowUserGuide(false)}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#1898c2",
              "&:hover": { backgroundColor: "#156f9a" },
              borderRadius: "8px",
              px: 4,
            }}
          >
            Close
          </StyledButton>
        </DialogActions>
      </Dialog>

      {paymentOption === "partial" && (
        <>
          <Box sx={{ marginBottom: "20px" }}>
            <StyledButton
              variant="contained"
              color="primary"
              onClick={handleSearchClick}
              disabled={isLoading || isSaved}
            >
              Select Student
            </StyledButton>
          </Box>

          <Box sx={{ marginBottom: "20px" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#1898c2",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Student Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Admission No."
                  value={selectedStudent ? selectedStudent.admissionNo : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleSearchClick}
                          disabled={isSaved}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Student Name"
                  value={
                    selectedStudent
                      ? selectedStudent.studentName
                      : "Select a student"
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Class"
                  value={selectedStudent ? selectedStudent.className : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Section"
                  value={selectedStudent ? selectedStudent.sectionName : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Roll No."
                  value={selectedStudent ? selectedStudent.rollNo : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Father's Name"
                  value={selectedStudent ? selectedStudent.fatherName : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
          </Box>

          {selectedStudent && (
            <Box sx={{ marginBottom: "40px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: "#1898c2",
                        marginBottom: "16px",
                        textAlign: "center",
                      }}
                    >
                      Payment for Month Details
                    </Typography>
                    {monthSelectionError && (
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#d32f2f",
                          marginBottom: "10px",
                          textAlign: "center",
                        }}
                      >
                        {monthSelectionError}
                      </Typography>
                    )}
                    {isMonthLoading && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <CircularProgress size={24} />
                      </Box>
                    )}
                    <FormControl
                      fullWidth
                      sx={{ marginBottom: "20px", maxWidth: 300 }}
                    >
                      <Select
                        value={selectedFinancialYear}
                        onChange={handleFinancialYearChange}
                        displayEmpty
                        variant="outlined"
                        size="small"
                        sx={{ borderRadius: "4px" }}
                      >
                        <MenuItem value="">Select Financial Year</MenuItem>
                        {financialYears.map((year) => (
                          <MenuItem
                            key={year.financialYearID}
                            value={year.financialYearID}
                          >
                            {year.finanacialYear}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <StyledTableContainer
                      component={Paper}
                      sx={{ maxHeight: 400, overflow: "auto" }}
                    >
                      <Table stickyHeader aria-label="fee details table">
                        <StyledTableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Select Payment
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Payment Date
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Month Name
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Fee Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Fine Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Concession Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Discount Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Paid Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Payment Status
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "10px",
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </StyledTableHead>
                        <TableBody>
                          {feeDetails.length === 0 ? (
                            <TableRow>
                              <TableCell
                                colSpan={10}
                                sx={{ textAlign: "center", padding: "20px" }}
                              >
                                <Typography
                                  variant="body1"
                                  color="text.secondary"
                                >
                                  No fee details found
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ) : (
                            feeDetails.map((fee) => (
                              <TableRow
                                key={fee.feePaymentId}
                                sx={{
                                  backgroundColor:
                                    fee.paidStaus === 1 ? "#c8e6c9" : "#fff", // ✅ stronger green
                                  "&:hover": { backgroundColor: "#b2dfdb" },
                                  "& .MuiTableCell-root": {
                                    fontWeight:
                                      fee.paidStaus === 1 ? "bold" : "normal",
                                    color:
                                      fee.paidStaus === 1
                                        ? "#1b5e20"
                                        : "inherit",
                                  },
                                }}
                              >
                                {/* Checkbox */}
                                <TableCell
                                  sx={{ padding: "8px", width: "60px" }}
                                >
                                  <Checkbox
                                    checked={selectedPayments.includes(
                                      fee.feePaymentId
                                    )}
                                    onChange={() =>
                                      handlePaymentSelect(fee.feePaymentId)
                                    }
                                    disabled={fee.paidStaus === 1 || isSaved}
                                  />
                                </TableCell>

                                {/* Payment Date */}
                                <TableCell
                                  sx={{ padding: "8px", width: "110px" }}
                                >
                                  <DatePicker
                                    selected={
                                      fee.paymentDate
                                        ? parseDate(fee.paymentDate)
                                        : new Date()
                                    }
                                    onChange={(date) =>
                                      handleDateChange(date, fee.feePaymentId)
                                    }
                                    dateFormat="dd-MM-yyyy"
                                    customInput={
                                      <CustomDateInput
                                        disabled={
                                          fee.paidStaus === 1 || isSaved
                                        }
                                      />
                                    }
                                    disabled={fee.paidStaus === 1 || isSaved}
                                  />
                                </TableCell>

                                {/* Month Name */}
                                <TableCell
                                  sx={{ padding: "8px", width: "100px" }}
                                >
                                  {fee.monthName}
                                </TableCell>

                                {/* Fee Amount */}
                                <TableCell
                                  sx={{
                                    padding: "8px",
                                    width: "100px",
                                    textAlign: "right",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    {fee.totalFee.toFixed(2)}
                                  </Typography>
                                </TableCell>

                                {/* Fine Amount */}
                                <TableCell
                                  sx={{ padding: "8px", width: "100px" }}
                                >
                                  <TextField
                                    type="number"
                                    value={fee.fine.toFixed(2)}
                                    onChange={(event) =>
                                      handleFineChange(event, fee.feePaymentId)
                                    }
                                    size="small"
                                    variant="outlined"
                                    disabled={fee.paidStaus === 1 || isSaved}
                                    sx={{
                                      width: "100px",
                                      "& .MuiInputBase-input": {
                                        fontSize: "0.75rem",
                                        fontWeight: "bold",
                                        textAlign: "right",
                                      },
                                    }}
                                    InputProps={{
                                      readOnly: fee.paidStaus === 1 || isSaved,
                                    }}
                                  />
                                </TableCell>

                                {/* Concession Amount */}
                                <TableCell
                                  sx={{ padding: "8px", width: "110px" }}
                                >
                                  <TextField
                                    value={(
                                      monthCharges[fee.feePaymentId]
                                        ?.concession || 0
                                    ).toFixed(2)}
                                    size="small"
                                    variant="outlined"
                                    disabled
                                    sx={{
                                      width: "100px",
                                      "& .MuiInputBase-input": {
                                        fontWeight: "bold",
                                        textAlign: "right",
                                      },
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </TableCell>

                                {/* Discount Amount */}
                                <TableCell
                                  sx={{ padding: "8px", width: "110px" }}
                                >
                                  <TextField
                                    value={fee.discountAmount.toFixed(2)}
                                    size="small"
                                    variant="outlined"
                                    disabled
                                    sx={{
                                      width: "100px",
                                      "& .MuiInputBase-input": {
                                        fontWeight: "bold",
                                        textAlign: "right",
                                      },
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </TableCell>

                                {/* Paid Amount */}
                                <TableCell
                                  sx={{ padding: "8px", width: "110px" }}
                                >
                                  <TextField
                                    value={fee.paidAmount.toFixed(2)}
                                    size="small"
                                    variant="outlined"
                                    disabled
                                    sx={{
                                      width: "100px",
                                      "& .MuiInputBase-input": {
                                        fontWeight: "bold",
                                        textAlign: "right",
                                      },
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </TableCell>

                                {/* Payment Status */}
                                <TableCell
                                  sx={{
                                    padding: "8px",
                                    width: "90px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {fee.paidStaus === 1 ? "Paid" : "Unpaid"}
                                </TableCell>

                                {/* Action */}
                               <TableCell sx={{ padding: "8px", width: "70px" }}>
  <Box sx={{ display: "flex", gap: 1 }}>
    <Tooltip title="Print Receipt">
      <IconButton
        onClick={() => {
          setPrintPaymentId(fee.transactionId);
          setShowPrintModal(true);
        }}
        disabled={fee.transactionId === 0}
      >
        <PrintIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title="Cancel Fee">
      <IconButton
        onClick={() => {
          setTransactionIdToCancel(fee.transactionId);
          setShowCancelConfirmation(true);
        }}
        disabled={fee.transactionId === 0 || fee.paidStaus !== 1}
        sx={{ color: "red" }}
      >
        <LoopIcon />
      </IconButton>
    </Tooltip>
  </Box>
</TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </StyledTableContainer>
                    {/* Removed Pay Selected Button */}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  {selectedPayments.length > 0 && (
                    <StyledCard sx={{ maxHeight: "300px", overflowY: "auto" }}>
                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            color: "#1898c2",
                            marginBottom: "16px",
                          }}
                        >
                          Month Charges
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table aria-label="charges table">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Serial No
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Month Name
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Charge Name
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Amount
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Fine Amount
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Days Late
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Month
                                </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>
                                  Charge Per Day
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {/* Within the Month Charges TableBody, replace the TextField with a read-only value */}
                            <TableBody>
                              {selectedPayments.length === 0 ? (
                                <TableRow>
                                  <TableCell
                                    colSpan={8}
                                    sx={{
                                      textAlign: "center",
                                      padding: "16px",
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      color="text.secondary"
                                    >
                                      No charges available
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                selectedPayments.flatMap(
                                  (feePaymentId, index) => {
                                    const fee = feeDetails.find(
                                      (f) => f.feePaymentId === feePaymentId
                                    );
                                    const {
                                      charges = [],
                                      fineDetails = {},
                                      transportFee = 0,
                                    } = monthCharges[feePaymentId] || {};
                                    const rows = [];
                                    charges.forEach((charge, chargeIndex) => {
                                      rows.push(
                                        <TableRow
                                          key={`charge-${feePaymentId}-${chargeIndex}`}
                                        >
                                          <TableCell>
                                            {rows.length + 1}
                                          </TableCell>
                                          <TableCell>
                                            {fee?.monthName || "N/A"}
                                          </TableCell>
                                          <TableCell>
                                            {charge.chargeName || "N/A"}
                                          </TableCell>
                                          <TableCell>
                                            ₹
                                            {(
                                              charge.chargerAmount || 0
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                        </TableRow>
                                      );
                                    });
                                    if (fineDetails.fineAmount > 0) {
                                      rows.push(
                                        <TableRow key={`fine-${feePaymentId}`}>
                                          <TableCell>
                                            {rows.length + 1}
                                          </TableCell>
                                          <TableCell>
                                            {fee?.monthName || "N/A"}
                                          </TableCell>
                                          <TableCell>Fine</TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>
                                            ₹
                                            {(
                                              fineDetails.fineAmount || 0
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {(fineDetails.day || 0).toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {(fineDetails.month || 0).toFixed(
                                              2
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            ₹
                                            {(
                                              fineDetails.chargePerDay || 0
                                            ).toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                    if (transportFee > 0) {
                                      rows.push(
                                        <TableRow
                                          key={`transport-${feePaymentId}`}
                                        >
                                          <TableCell>
                                            {rows.length + 1}
                                          </TableCell>
                                          <TableCell>
                                            {fee?.monthName || "N/A"}
                                          </TableCell>
                                          <TableCell>Transport Fee</TableCell>
                                          <TableCell>
                                            ₹{(transportFee || 0).toFixed(2)}
                                          </TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                          <TableCell>-</TableCell>
                                        </TableRow>
                                      );
                                    }
                                    return rows;
                                  }
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </StyledCard>
                  )}
       <StyledCard>
  <CardContent sx={{ p: 3 }}>
    {/* Header */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 3,
        pb: 2,
        borderBottom: "1.5px solid #e3f2fd",
      }}
    >
      <Box
        sx={{
          width: 4,
          height: 24,
          borderRadius: 1,
          backgroundColor: "#1898c2",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, color: "#1898c2", letterSpacing: 0.3 }}
      >
        Fee Calculation
      </Typography>
    </Box>

    <Grid container spacing={2.5}>

      {/* ── Section: Base Charges ── */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Monthly Fee Amount"
              value={selectedPayments
                .reduce((sum, id) => {
                  const fee = feeDetails.find((f) => f.feePaymentId === id);
                  const charges = monthCharges[id]?.charges || [];
                  const chargeTotal = charges.reduce(
                    (acc, charge) => acc + (charge.chargerAmount || 0),
                    0
                  );
                  return sum + chargeTotal;
                }, 0)
                .toFixed(2)}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              sx={readOnlyFieldSx}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Fine Amount"
              value={selectedPayments
                .reduce(
                  (sum, id) =>
                    sum +
                    (feeDetails.find((f) => f.feePaymentId === id)?.fine || 0),
                  0
                )
                .toFixed(2)}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              sx={readOnlyFieldSx}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* ── Section: Additional Charges ── */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Transport Charges"
              value={selectedPayments
                .reduce(
                  (sum, id) => sum + (monthCharges[id]?.transportFee || 0),
                  0
                )
                .toFixed(2)}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              sx={readOnlyFieldSx}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Hostel Charges"
              value={selectedPayments
                .reduce(
                  (sum, id) => sum + (monthCharges[id]?.hostelCharges || 0),
                  0
                )
                .toFixed(2)}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              sx={readOnlyFieldSx}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* ── Grand Total ── */}
      <Grid item xs={12}>
        <TextField
          label="Grand Total (Fines, Hostel & Transport)"
          value={calculateTotalMonthlyFee().toFixed(2)}
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">₹</InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#f0f7ff",
              fontWeight: 700,
              borderRadius: "8px",
              "& fieldset": { borderColor: "#1898c2", borderWidth: "1.5px" },
            },
            "& .MuiInputLabel-root": { fontWeight: 600, color: "#1898c2" },
          }}
        />
      </Grid>

{/* ── Previously Paid Amount ── */}
<Grid item xs={12}>
  <TextField
    label="Previously Paid Amount"
    value={previousPaidAmount.toFixed(2)}
    fullWidth
    size="small"
    variant="outlined"
    InputProps={{
      readOnly: true,
      startAdornment: (
        <InputAdornment position="start">₹</InputAdornment>
      ),
    }}
sx={{
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f8eff2",        // light rose
    fontWeight: 700,
    borderRadius: "8px",
    "& fieldset": { borderColor: "#f5bace", borderWidth: "1.5px" },  // muted pink
  },
  "& .MuiInputLabel-root": { fontWeight: 600, color: "#c14778" },    // deep rose
}}
  />
</Grid>

      {/* ── Section: Deductions ── */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Concession"
              value={concessionAmount.toFixed(2)}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              sx={readOnlyFieldSx}
            />
          </Grid>
         <Grid item xs={12} sm={6}>
  <TextField
    label="Discount Amount"
    type="number"
    value={discountAmount}
    onChange={handleDiscountAmountChange}
    fullWidth
    size="small"
    variant="outlined"
    disabled={isSaved || isOtpSent}
    InputProps={{
      startAdornment: <InputAdornment position="start">₹</InputAdornment>,
    }}
  />
  {discountAmount > 0 && !isOtpSent && (
    <TextField
      label="Discount Reason"
      value={discountReason}
      onChange={(e) => setDiscountReason(e.target.value)}
      fullWidth
      size="small"
      variant="outlined"
      sx={{ mt: 1 }}
      placeholder="Enter reason for discount"
    />
  )}
  {discountAmount > 0 && !isOtpSent && (
    <Button
      variant="outlined"
      size="small"
      onClick={handleSendDiscountOtp}
      disabled={!discountReason.trim()}
      sx={{ mt: 1, width: "100%" }}
    >
      Send Discount OTP
    </Button>
  )}
  {isOtpSent && (
    <TextField
      label="Enter Discount OTP"
      value={discountOtp}
      onChange={(e) => setDiscountOtp(e.target.value)}
      fullWidth
      size="small"
      variant="outlined"
      sx={{ mt: 1 }}
    />
  )}
</Grid>
        </Grid>
      </Grid>

      {/* ── Amount After Discount ── */}
      <Grid item xs={12}>
        <TextField
          label="Amount After Discount"
          value={calculateAmountAfterDiscount().toFixed(2)}
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">₹</InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#e8f5e9",
              fontWeight: 700,
              borderRadius: "8px",
              "& fieldset": { borderColor: "#43a047", borderWidth: "1.5px" },
            },
            "& .MuiInputLabel-root": { fontWeight: 600, color: "#2e7d32" },
          }}
        />
      </Grid>

      {/* ── Section: Payment ── */}
      <Grid item xs={12}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            color: "#888",
            textTransform: "uppercase",
            letterSpacing: 1,
            display: "block",
            mb: 1,
          }}
        >
          Payment
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Pay Amount"
              type="number"
              value={paidAmount}
              onChange={handlePaidAmountChange}
              fullWidth
              size="small"
              variant="outlined"
              disabled={isSaved}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
                inputProps: { style: { MozAppearance: "textfield" } },
                sx: {
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    { display: "none" },
                  "& input": { MozAppearance: "textfield" },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <Select
                value={paymentMode}
                onChange={handlePaymentModeChange}
                displayEmpty
                variant="outlined"
                disabled={isSaved}
              >
                <MenuItem value="">Select Payment Mode</MenuItem>
                {banks.map((bank) => (
                  <MenuItem key={bank.bankId} value={bank.bankId}>
                    {bank.bankName}{" "}
                    {bank.accountNo ? `(${bank.accountNo})` : ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      {/* ── Monthly Balance ── */}
      <Grid item xs={12}>
        <TextField
          label="Monthly Balance"
          value={calculateMonthlyBalance().toFixed(2)}
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">₹</InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#fff8e1",
              fontWeight: 700,
              borderRadius: "8px",
              "& fieldset": { borderColor: "#f9a825", borderWidth: "1.5px" },
            },
            "& .MuiInputLabel-root": { fontWeight: 600, color: "#f57f17" },
          }}
        />
      </Grid>

    </Grid>
  </CardContent>
</StyledCard> 
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ textAlign: "center", marginTop: "20px" }}>
          {!isOnlinePayment ? (
  <StyledButton
    variant="contained"
    color="primary"
    onClick={handlePartialPaymentSubmit}
    disabled={
      !selectedStudent ||
      isSaved ||
      paidAmount <= 0 ||
      paidAmount > parseFloat(calculateTotalMonthlyFee())
    }
    sx={{ marginRight: "10px" }}
  >
    Save
  </StyledButton>
) : (
  <StyledButton
    variant="contained"
    color="primary"
    onClick={handlePayOnline}
    disabled={
      !selectedStudent ||
      isSaved ||
      paidAmount <= 0 ||
      paidAmount > parseFloat(calculateTotalMonthlyFee())
    }
    sx={{ marginRight: "10px" }}
  >
    Pay Online
  </StyledButton>
)}
            <StyledButton
              variant="contained"
              color="error"
              onClick={handleCancel}
              disabled={!selectedStudent && !isSaved}
              sx={{ marginRight: "10px" }}
            >
              Cancel
            </StyledButton>
            <StyledButton
              onClick={() => generateReceipt(savedPaymentId, false)}
              color="primary"
              variant="contained"
              disabled={!isSaved}
            >
              Generate Receipt
            </StyledButton>
          </Box>
        </>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={messageColor}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <BootstrapModal
        show={showStudentModal}
        onHide={() => setShowStudentModal(false)}
        centered
        dialogClassName="custom-modal"
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Select Student</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Select
                  value={selectedClass}
                  onChange={handleClassChange}
                  displayEmpty
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: "4px" }}
                >
                  <MenuItem value="">Select Class</MenuItem>
                  {classes.map((cls) => (
                    <MenuItem key={cls.classId} value={cls.classId}>
                      {cls.className}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Search by Name or Admission No."
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e) => {
                  const searchTerm = e.target.value.toLowerCase();
                  const filtered = students.filter(
                    (student) =>
                      student.studentName.toLowerCase().includes(searchTerm) ||
                      student.admissionNo.toLowerCase().includes(searchTerm)
                  );
                  setStudents(filtered);
                  if (!searchTerm && selectedClass) {
                    fetchStudents(selectedClass);
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <Table stickyHeader aria-label="student selection table">
              <TableHead>
                <TableRow>
                  <TableCell>Admission No.</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Section</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {students.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5}>No students found</TableCell>
                  </TableRow>
                ) : (
                  students.map((student) => (
                    <TableRow
                      key={student.studentId}
                      sx={{
                        "&:hover": { backgroundColor: "#e0f7fa" },
                      }}
                    >
                      <TableCell>{student.admissionNo}</TableCell>
                      <TableCell>{student.studentName}</TableCell>
                      <TableCell>{student.className}</TableCell>
                      <TableCell>{student.sectionName}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => handleStudentSelect(student)}
                        >
                          Select
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </BootstrapModal.Body>
      </BootstrapModal>
      <Dialog
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Payment Successful</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Your fee deposit was successful. Click the button below to generate
            the receipt.
          </Typography>
          <RadioGroup
            value={receiptCopies}
            onChange={(e) => setReceiptCopies(e.target.value)}
            row
            sx={{ marginTop: 2 }}
          >
            <FormControlLabel
              value="one"
              control={<Radio />}
              label="Generate One Copy"
            />
            <FormControlLabel
              value="two"
              control={<Radio />}
              label="Generate Two Copies"
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <StyledButton
            onClick={() => setShowSuccessModal(false)}
            color="error"
            variant="contained"
          >
            Cancel
          </StyledButton>
          <StyledButton
            onClick={() => generateReceipt(savedPaymentId, false)}
            color="primary"
            variant="contained"
          >
            Generate Receipt
          </StyledButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Generate Receipt</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Select the number of copies to generate.
          </Typography>
          <RadioGroup
            value={receiptCopies}
            onChange={(e) => setReceiptCopies(e.target.value)}
            row
            sx={{ marginTop: 2 }}
          >
            <FormControlLabel
              value="one"
              control={<Radio />}
              label="Generate One Copy"
            />
            <FormControlLabel
              value="two"
              control={<Radio />}
              label="Generate Two Copies"
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <StyledButton
            onClick={() => setShowPrintModal(false)}
            color="error"
            variant="contained"
          >
            Cancel
          </StyledButton>
          <StyledButton
            onClick={() => {
              generateReceipt(printPaymentId, true);
              setShowPrintModal(false);
            }}
            color="primary"
            variant="contained"
          >
            Generate Receipt
          </StyledButton>
        </DialogActions>
      </Dialog>
      <Dialog
  open={showCancelConfirmation}
  onClose={() => setShowCancelConfirmation(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Confirm Fee Cancellation</DialogTitle>
 <DialogContent>
  <Typography variant="body1" gutterBottom>
    Are you sure you want to cancel this fee transaction?
  </Typography>
  <Typography variant="body2" color="text.secondary" gutterBottom>
    This action cannot be undone.
  </Typography>
  <TextField
    label="Cancel Reason"
    value={cancelReason}
    onChange={(e) => setCancelReason(e.target.value)}
    fullWidth
    multiline
    rows={2}
    variant="outlined"
    sx={{ mt: 2 }}
    required
  />
</DialogContent>
<DialogActions>
  <StyledButton
    onClick={() => {
      setShowCancelConfirmation(false);
      setCancelReason("");
    }}
    color="primary"
    variant="outlined"
  >
    No, Keep It
  </StyledButton>
 <Tooltip title={!cancelReason.trim() ? "Please enter a valid reason for Fee cancellation" : ""}>
  <span>
    <StyledButton
  onClick={handleSendCancelOtp}
  color="error"
  variant="contained"
  disabled={!cancelReason.trim()}
>
  Send OTP
</StyledButton>
  </span>
</Tooltip>
</DialogActions>
  
</Dialog>


{/* Step 2: OTP Dialog */}
<Dialog open={showCancelOtpDialog} onClose={() => setShowCancelOtpDialog(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Enter Cancellation OTP</DialogTitle>
  <DialogContent>
    <Typography variant="body2" gutterBottom>An OTP has been sent. Please enter it below to confirm cancellation.</Typography>
    <TextField
      label="Enter OTP"
      value={cancelOtp}
      onChange={(e) => setCancelOtp(e.target.value)}
      fullWidth variant="outlined" sx={{ mt: 2 }}
    />
  </DialogContent>
  <DialogActions>
    <StyledButton onClick={() => { setShowCancelOtpDialog(false); setCancelOtp(""); }} color="primary" variant="outlined">Back</StyledButton>
    <StyledButton onClick={handleCancelFee} color="error" variant="contained" disabled={!cancelOtp.trim()}>Confirm Cancel</StyledButton>
  </DialogActions>
</Dialog>
    </StyledContainer>
  );
}

export default FeeDeposit;
